var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"position-relative"},[_c('date-timepicker',{attrs:{"enableTime":false,"value":_vm.value,"placeholder":_vm.$t('datatable.search.date.placeholder')},on:{"change":_vm.setValue,"clear":_vm.clearValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }